const MuiTextField = {
  root: {
    fontSize: '1.6rem',
  },
};

export default MuiTextField;
